import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import InputBox from '../../component/InputBox';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Button from '../../component/Button';
import { useForm, FormProvider, } from 'react-hook-form';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useWatch } from 'react-hook-form';
import { createNewPassword } from '../../redux/reducers/authSlice';
import { Toast } from '../../service/toast';

const CreateNewPassword = () => {
    const navigate = useNavigate();
    const [newPasswordShown, setNewPasswordShown] = useState(true);
    const [rePasswordShown, setRePasswordShown] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const [isConfirmPasswordDisabled, setIsConfirmPasswordDisabled] = useState(true)

    const token = searchParams.get("token");
    const email = searchParams.get("email")
    
    const formMethods = useForm({
        mode: "onChange",
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        getValues,
        control,
        watch
    } = formMethods;
    const togglePassword = () => {
        setNewPasswordShown((prevState) => !prevState);
    }
    const toggleShowPassword = () => {
        setRePasswordShown((prevState) => !prevState);
    }
    const backToLogin = () => {
        navigate('/auth/login');
    }

    const navigateToSucess = () => {
        navigate('/auth/success');
    }
    const confirmPasswordValue = useWatch({
        control,
        name : "password",
    })

    const onSubmit = (data) => {
        const requestData ={
            email : email,
            newPassword : data.confirmPassword,
            token : token
        }

        createNewPassword(requestData)
        .then((res) =>{
            navigateToSucess();
        })
        .catch((err) =>{
            Toast({
                type: 'error',
                message: 'Failed to set New Password. Please try again.'
              });
        })
    };

    useEffect(() =>{
        return confirmPasswordValue ? setIsConfirmPasswordDisabled(false) : setIsConfirmPasswordDisabled(true)
    },[confirmPasswordValue])


    return (
        <div className='flex items-center justify-center'>
            <div className={`${classes.forgotPassword}`}>
                <p className={`${classes.forgotHeader} mb-5`}>CREATE NEW PASSWORD</p>
                <p className={`${classes.forgotText} mb-8`}>Your new password must be different from previously used passwords.</p>
                <FormProvider {...formMethods}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='!mb-6'>
                            <InputBox
                                label={"Password"}
                                type={newPasswordShown ? "text" : "password"}
                                icon={(newPasswordShown) ? <RemoveRedEyeOutlinedIcon sx={{ color: "black" }} onClick={togglePassword} /> : <VisibilityOffOutlinedIcon sx={{ color: "black" }} onClick={togglePassword} />}
                                className={`${classes.passwordInput} w-[100%] `}
                                name={"newPassword"}
                                authInput
                                {...register("password", {
                                    minLength: {
                                        value: 6,
                                        message: "Minimum 6 characters required",
                                    },
                                })}
                                error={errors.password}
                                messages={{
                                    required: "Password is required",
                                    minLength: "Minimum 6 characters required",
                                }}
                            />
                        </div>
                        <div className='!mb-12'>
                            <InputBox
                                label={"Confirm Password"}
                                icon={(rePasswordShown) ? <RemoveRedEyeOutlinedIcon sx={{ color: "black" }} onClick={toggleShowPassword} /> : <VisibilityOffOutlinedIcon sx={{ color: "black" }} onClick={toggleShowPassword} />}
                                className={`${classes.passwordInput} w-[100%] `}
                                type={rePasswordShown ? "text" : "password"}
                                name={"confirmPassword"}
                                authInput
                                {...register("confirmPassword", {
                                    minLength: {
                                        value: 6,
                                        message: "Minimum 6 characters required",
                                    },
                                    validate: (value) => value === getValues("password") || "Password does not match"
                                })}
                                onPaste={(e) => e.preventDefault()}
                                onCopy={(e) =>e.preventDefault() }
                                disabled={isConfirmPasswordDisabled}
                                error={errors?.confirmPassword}
                                messages={{
                                    required: "Confirm Password is required",
                                    validate: "Passwords do not match",
                                    minLength: "Minimum 6 characters required"
                                }}
                            />
                        </div>
                        <Button text={"Reset Password"} className={`w-[100%] mb-[80px]`}  />
                    </form>
                </FormProvider>
                <div className='text-center'>
                    <label className={`${classes.backToLogin}`} onClick={backToLogin}>Back to Login</label>
                </div>
            </div>
        </div>
    );
}

export default CreateNewPassword;
